export const locale = {
  lang: 'nl',
  data: {
    'NOTIFICACIONES': {
      'INFO': {
        'HOY': 'Vandaag',
        'TITUNOT': 'Kennisgevingen',
        'NOTTTIP': 'Markeer als gelezen'
      },
      'EDITOR_EMAILS': {
        'NUEVAMOD': 'Het bedrijf <b>-ALVPRRO-</b> heeft een wijziging aangebracht in een of meer van zijn communicatiemails',
        'NUEVAMODODS': 'Een projectmanager heeft wijzigingen aangebracht in één of meer communicatiemails voor het bedrijf <b>-ALVPRRO-</b>'
      },
      'AUTORI-ENCUESTA': {
        'AUTORIZAR-ENCUESTA': 'Het bedrijf <b>-ALVPRRO-</b> heeft de enquête laten goedkeuren',
      },
    },
    'NOTIFICACION_PRODUCT':{
      'PRODUCTOS_ID':{
        '20':'Certificeren',
        '40': 'Certificeren 3.0',
        '41':'Meten 3.0',
        '42': 'Pulsecheck 3.0',
        '43': 'Aandachtsgebied',
        '56': 'AMCO',
        '57': 'Fatsoenlijk werk',
        '58':'Eerste baan',
      },
      'TIPO_MENSAJE_MOSTRAR':{
        'languageNative':'U hebt de hoofdtaal geselecteerd',
        'sinAdicionales':'U hebt geen extra talen geselecteerd',
        'languageAdittional':'U hebt de extra talen geselecteerd',
        'conAdicionales':'U heeft de selectie zonder extra talen ongedaan gemaakt ',
        'deleteLangNative':'U heeft de moedertaal verwijderd',
        'completPasLang':'U heeft de taalstap voltooid',
        'completePasTemplate': 'U hebt de sjabloonstap voltooid',
        'completePasReacti': 'U hebt de reagensstap voltooid',
        'completePasNps': 'U hebt de stap nps voltooid',
        'completePasControl': 'U hebt de controlestap voltooid',
        'completePasDemogra': 'U hebt de demografische stap voltooid',
        'completePasAbierta': 'U hebt de open stap voltooid',
        'completPasAdicio': 'U hebt de aanvullende stap voltooid',
        'completePas4all': 'U heeft de forall stap voltooid',
        'completePasEncues': 'U hebt de enquête-stap voltooid',
        'completePasColab': 'U hebt de stap medewerkers voltooid',
        'voltooiPasEnvi': 'U hebt de stap verzenden voltooid',
        'completePasEstat': 'U hebt de stap Enquêtestatus voltooid',
        'completPasProgra': 'U hebt de stap programmering voltooid',
        'DescompletePasLang': 'U hebt de taalstap afgebroken',
        'DescompletePasTemplate': 'U hebt de stap template gedescompleteerd',
        'DescompletePasReacti': 'U heeft de reagens stap niet voltooid',
        'DescompletePasNps': 'U heeft de nps-stap afgebroken',
        'DescompletePasControl': 'U hebt de controlestap afgebroken',
        'DescompletePasDemogra': 'U hebt de demografische stap niet voltooid',
        'DescompletePasAbierta': 'U heeft de open stap niet voltooid',
        'DescompletePasAdicio': 'U heeft de aanvullende stap niet voltooid',
        'DescompletePas4all': 'U heeft de forall stap niet voltooid',
        'DescompletePasEncues': 'U heeft de enquête stap niet voltooid',
        'DescompletePasColab': 'U heeft de stap collaborateurs niet voltooid',
        'DescompletePasEnvi': 'U heeft de stap verzenden niet voltooid',
        'DescompletePasEstat': 'U hebt de stap Enquêtestatus niet voltooid',
        'DescompletePasProgra': 'U hebt de programmeerstap niet voltooid',
        'createSurvey': 'Enquête is aangemaakt',
        'saveUserDemo': 'U heeft de demo-gebruikers in de enquête opgeslagen',
        'recreateSurvey': 'De enquête is opnieuw aangemaakt',
        'saveSeccionNps': 'Het nps-gedeelte is opgeslagen in de enquête',
        'saveSeccionReactivos': 'De sectie reagentia is opgeslagen in de enquête',
        'saveSeccionControl': 'Het onderdeel controle is in de enquête opgeslagen',
        'saveSeccionDemogra': 'Het demografische gedeelte is in de enquête opgeslagen',
        'saveSeccionAbier': 'Het open gedeelte is in de enquête opgeslagen',
        'saveSeccionForall': 'Forall sectie is opgeslagen in de enquête',
        'saveSeccionAdicio': 'Het aanvullende gedeelte is in de enquête opgeslagen',
        'downloadBaseColab': 'De contributor base is gedownload',
        'deleteBaseColab': 'Het medewerkersbestand is verwijderd',
        'saveUsersSurvey': 'De medewerkers aan de enquête zijn opgeslagen',
        'regisFechaLanza': 'De lanceerdatum van de enquête is geregistreerd',
        'regisFechaAviso1': 'De datum van kennisgeving 1 voorafgaand aan de enquête is vastgelegd',
        'regisFechaAviso2': 'De datum van waarschuwing 2 voorafgaand aan de enquête is vastgelegd',
        'saveRecordatorioEncu': 'Er is een herinnering vastgelegd',
        'enviarCorreos': 'U heeft ervoor gekozen om mail te sturen naar uw medewerkers',
        'noEnviarCorreos': 'U heeft ervoor gekozen geen mail te sturen naar uw medewerkers',
        'cambiarEstatusCorreo': 'U heeft de wijziging doorgevoerd om de verzending van mail te wijzigen',
        'ActivaEstatEncu': 'De enquête is geactiveerd',
        'DesacEstatEncu': 'De enquête is gedeactiveerd',
        'activoSeccionNps': 'Het NPS-gedeelte is geactiveerd voor de enquête',
        'desActivoSeccionNps': 'Het NPS-gedeelte is gedeactiveerd voor de enquête',
        'activoSeccionReactivos':'Het REACTIVE gedeelte is geactiveerd voor de enquête',
        'desActivoSeccionReactivos':'De sectie REACTIVOS is gedeactiveerd voor de enquête',
        'activoSeccionControl': 'Het onderdeel CONTROL is geactiveerd voor de enquête',
        'desActivoSeccionControl':'Het onderdeel CONTROL is gedeactiveerd voor de enquête',
        'activoSeccionDemograficos': 'De sectie DEMOGRAFIE is geactiveerd voor de enquête',
        'desActivoSeccionDemograficos': 'De sectie DEMOGRAPHICS is gedeactiveerd voor de enquête',
        'activoSeccionAbiertas': 'Het onderdeel OPEN is geactiveerd voor de enquête',
        'desActivoSeccionAbiertas': 'De sectie ABIERTAS para la encuesta is gedeactiveerd',
        'activoSeccionForall': 'De sectie FORALL is geactiveerd voor de enquête',
        'desActivoSeccionForall': 'Het FORALL-gedeelte is gedeactiveerd voor de enquête',
        'activoSeccionAdicionales':'De sectie ADDITIONAL is geactiveerd voor de enquête',
        'desActivoSeccionAdicionales':'Het onderdeel ADDITIONAL is gedeactiveerd voor de enquête',
        'deletePregTemNps': 'De vraag is verwijderd uit de NPS-sectie',
        'deletePregTemReacti': 'De vraag is verwijderd uit de REACTIVES sectie',
        'deletePregTemControl': 'De vraag is verwijderd uit de CONTROL-sectie',
        'deletePregTemDemogra': 'De vraag is verwijderd uit de sectie DEMOGRAPHICS',
        'deletePregTemAbier': 'De vraag is verwijderd uit de rubriek OPEN',
        'deletePregTemAdici':'De vraag is verwijderd uit de rubriek ADDITIONAL',
        'savePregCatNps':'Catalogusvraag is opgeslagen in de NPS-sectie',
        'savePregCatReacti': 'De catalogusvraag is opgeslagen in de sectie REAGENTIA',
        'savePregCatControl':'De catalogusvraag is opgeslagen in de CONTROL sectie',
        'savePregCatDemogra':'De catalogusvraag is opgeslagen in de sectie DEMOGRAPHICS',
        'savePregCatAbier':'De catalogusvraag is opgeslagen in de sectie OPEN',
        'savePregCatAdici':'De catalogusvraag is opgeslagen in de ADDITIONALS sectie',
        'savePregNueNps':'Nieuwe vraag is opgeslagen in de NPS sectie',
        'savePregNueReacti':'Nieuwe vraag is opgeslagen in de REAGENTIA sectie',
        'savePregNueControl':'De nieuwe vraag is opgeslagen in de CONTROL sectie',
        'savePregNueDemogra':'Nieuwe vraag is opgeslagen in de sectie DEMOGRAPHICS',
                'savePregNueAbier': 'Nieuwe vraag is opgeslagen in de sectie OPEN',
                'savePregNueAdici':'Nieuwe vraag is opgeslagen in de ADDITIONALS sectie',
                'editPregNps': 'De vraag is bewerkt in de NPS-sectie',
                'editPregReacti': 'Vraag in REAGENTIA-gedeelte is bewerkt',
                'editPregControl': 'Vraag in CONTROL-gedeelte is bewerkt',
                'editPregDemogra': 'Vraag in het gedeelte DEMOGRAPHICS is bewerkt',
                'editPregAbier': 'Vraag in de OPEN sectie is bewerkt',
                'editPregAdici': 'Vraag in de ADDITIONELE sectie is bewerkt',
                'LogOut':'U bent uitgelogd',
                'reiniciarLang':'U hebt het product opnieuw opgestart',
                'accionText':'',
                'updatCuesForall':'The questionnaire of the forall section has been updated.',
                'savePracticaForall':'De praktijk voor allen is gered',
                'saveDescripForall':'De beschrijving van de praktijk voor allen is opgeslagen.',

      },
      'BTN_MOSTRAR_HISTO': 'Toon geschiedenis',
      'ETI_PRODUC': 'Product:',
      'TITLE_HISTO_PROD': 'Productgeschiedenis',
      'CARG_INFOR': 'Laadinformatie',
      'TITLE_FILTER': 'Filter:',
      'DELETE_FILTER': 'Filters verwijderen',
      'FILTER_1': 'Datum:',
      'BUSCAR_FILTER': 'Zoeken',
      'TH_TITTLE': 'Productgeschiedenis',
      'BTN_FILTER_HISTO': 'Filtergeschiedenis',
      'TD_USUARIO':'Gebruiker:',
      'TD_FECHA_PRODU':'Productdatum:',
      'TD_TIPO_PRODU':'Producttype:',
      'TD_TIPO_USU_ADMI': 'Beheerder gebruiker',
      'WARNING_NO_DATOS': 'Geen informatie om weer te geven',

    }

  }
};
